module.exports = function UpdateSourceUpdateResponse(error) {
    this.error = error;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-response.js
// module id = 316
// module chunks = 1